<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import ErrorPage from '../ErrorPage/ErrorPage.vue';

const route = useRoute();

const message = computed(() => {
  if (!route?.query?.message) return 'De pagina die je zoekt kon niet worden gevonden...';
  return String(route.query.message);
});
</script>

<template>
  <ErrorPage
    title="404"
    sub-title="Probleem tijdens het laden van de pagina"
    :description="message"
  />
</template>
